import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { translate } from '../../../../../I18n/i18n';
import './PopUpFilter.scss';

interface PopUpFilterProps extends WithTranslation{
    show: boolean;
    onClose: () => void;
    onSubmit: (filters: { dateFrom: string; dateTo: string; contentType: string }) => void;
}

interface PopUpFilterState {
    dateFrom: string;
    dateTo: string;
    contentType: string;
    errorMessage: string;  // Para manejar el error de validación
}

class PopUpFilter extends React.Component<PopUpFilterProps, PopUpFilterState> {
    constructor(props: PopUpFilterProps) {
        super(props);
        this.state = {
            dateFrom: '',
            dateTo: '',
            contentType: 'posts',
            errorMessage: '', // Inicializamos el estado para el mensaje de error
        };
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        this.setState({ [name]: value } as Pick<PopUpFilterState, keyof PopUpFilterState>);
    };

    handleSubmit = () => {
        const { dateFrom, dateTo, contentType } = this.state;

        // Validar que la fecha desde no sea mayor a la fecha hasta
        if (dateFrom && dateTo && new Date(dateFrom) > new Date(dateTo)) {
            this.setState({ errorMessage: translate(this.props.t, 'news.TR_DATE_FROM_AFTER_TO') });
            return; // Evita que se envíen los filtros si la validación falla
        }

        // Si la validación pasa, limpiamos el error y enviamos los filtros
        this.setState({ errorMessage: '' });
        this.props.onSubmit({ dateFrom, dateTo, contentType });
    };

    render() {
        const { show, onClose } = this.props;
        const { dateFrom, dateTo, contentType, errorMessage } = this.state;
        const { t } = this.props;

        if (!show) return null;

        return (
            <div className="popupFilter">
                <div className="popupFilter-overlay" onClick={onClose}></div>
                <div className="popupFilter-container">
                    <button className="popupFilter-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>

                    <div className="popupFilter-content">
                        <div className="popupFilter-filters">
                            <div className="popupFilter-date">
                                <label htmlFor="dateFrom">{translate(t, 'news.TR_DATE_FROM_LABEL')}</label>
                                <input
                                    type="date"
                                    id="dateFrom"
                                    name="dateFrom"
                                    value={dateFrom}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="popupFilter-date">
                                <label htmlFor="dateTo">{translate(t, 'news.TR_DATE_UNTIL_LABEL')}</label>
                                <input
                                    type="date"
                                    id="dateTo"
                                    name="dateTo"
                                    value={dateTo}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="popupFilter-dropdown">
                                <label htmlFor="contentType">{translate(t, 'news.TR_CONTENT_TYPE_LABEL')}</label>
                                <select
                                    id="contentType"
                                    name="contentType"
                                    value={contentType}
                                    onChange={this.handleChange}
                                >
                                    <option value="posts">{translate(t, 'news.TR_CONTENT_TYPE_NEWS_LABEL')}</option>
                                    <option value="documents">{translate(t, 'news.TR_CONTENT_TYPE_DOCUMENTS_LABEL')}</option>
                                </select>
                            </div>
                        </div>

                        {/* Mostrar el mensaje de error si hay uno */}
                        {errorMessage && <div className="error-message">{errorMessage}</div>}

                        <div className="popupFilter-submit">
                            <button onClick={this.handleSubmit} className="btn btn-primary">
                                {translate(t, 'news.TR_SEND_FILTERS_LABEL')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(PopUpFilter);
